export const getCommonWelcomePostPayload = (welcomePost) => {
    return {
        core: {
            title: welcomePost.title,
            description: welcomePost.description || '',
        },
    };
};
